export enum XolaBotAssistType {
    AUTOMATION_ENGINE = "XolaBot - Automation Engine",
    LIGHTNING_DEALS = "XolaBot - Lightning Deals",
    RESUME_BOOKING = "XolaBot - Resume Booking",
    UPSELL_ADDONS = "XolaBot - Upsell Add-ons",
    UPSELL_PACKAGES = "XolaBot - Upsell Packages",
    PRIVATE_RESERVATIONS = "XolaBot - Private Reservations",
}

export const XolaBotAssistTypeCopy: { [key in XolaBotAssistType]: string } = {
    [XolaBotAssistType.AUTOMATION_ENGINE]: "Automation Engine",
    [XolaBotAssistType.LIGHTNING_DEALS]: "Lightning Deals",
    [XolaBotAssistType.RESUME_BOOKING]: "Resume Booking",
    [XolaBotAssistType.UPSELL_ADDONS]: "Upsell Add-ons",
    [XolaBotAssistType.UPSELL_PACKAGES]: "Upsell Package",
    [XolaBotAssistType.PRIVATE_RESERVATIONS]: "Private Reservations",
};
